<template>
  <div class="trainIndex">
    <Header title="申请"></Header>
    <div class="train">
      <div class="list-head">
        <p>{{ list.kcmc }}[{{ list.kcbh }}]</p>
        <van-row>
          <van-col span="12">
            <ul>
              <li>课程性质：{{ list.kcxz }}</li>
              <li>课程类别：{{ list.kclb }}</li>
              <li>录入方式：{{ list.lrfs }}</li>
            </ul>
          </van-col>
          <van-col span="12">
            <ul>
              <li>学时：{{ list.zxs }}</li>
              <li>学分：{{ list.xf }}</li>
              <li>总成绩：{{ list.zcj }}</li>
            </ul>
          </van-col>
        </van-row>
      </div>
      <van-field
        v-model="cjxm.mc"
        label="成绩项目"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="onShow('成绩项目', 'cjxm')"
        readonly
      />
      <van-field
        v-if="this.cjxm.dm != 'zcj'"
        v-model="xmcj"
        label="项目成绩"
        input-align="right"
        readonly
        placeholder="请点击选择项目成绩"
      />
      <van-field
        v-if="this.cjxm.dm != 'zcj'"
        v-model="cjbl"
        label="成绩比例"
        input-align="right"
        readonly
        placeholder="请点击选择项目成绩"
      />
      <van-field
        v-model="sqyy"
        rows="1"
        autosize
        label="申请原因"
        type="textarea"
        maxlength="200"
        placeholder="请点击填写"
      />
      <div class="apply-input"  v-if="params.ck!='1'">
          <p>上传附件</p>
          <van-uploader
            v-model="fileList"
            :after-read="afterRead"
            :max-size="10 * 1024 * 1024"
            @oversize="onOversize"
            :max-count="1"
          > <div class="fujianImg"></div></van-uploader>
     </div>
     <div class="apply-input"  v-else>
          <p>附件</p>
          <span style="color:blue" @click="CheckFile">{{qzwffilename}}</span>
     </div>
     <div class="apply-input"  v-if="params.ck=='0'">
          <p>附件</p>
          <span style="color:blue" @click="CheckFile">{{qzwffilename}}</span>
     </div>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
      />
    </van-popup>
    <div v-if="params.ck != '1' && params.ck != '0'" class="bottom-btn">
      <button @click="save()">保存并送审</button>
    </div>
    <div v-else-if="params.ck == '0'" class="bottom-btn1">
      <button @click="save()">保存并送审</button>
      <button @click="del()">删除</button>
    </div>
  </div>
</template>

<script>
import { Api } from "../../../../utils/axios";
export default {
  data() {
    return {
      show: false,
      cjxm: {},
      xmcj: "",
      cjbl: "",
      sqyy: "",
      list: [],
      params: [],
      columns: {},
      fileList:[],
      file: {},
      valueList: {
        label: "",
        value: "",
        item: []
      },
      fileurl:'',
      qzwffilename:'',
      fileYlData:{},
      isUpLpadFile:'0'
    };
  },
  created() {
    if(this.$route.query.isback=='1'){
      this.params = this.$route.list;
    }else{
      this.params = this.$route.query.list;
    }
    this.getList();
  },
  methods: {
    async del() {
      const res = await Api.delecjsq({
        cjfhsqid: this.params.cjfhsqid
      });
      if (res.code == 1) {
        this.$toast.success("删除成功!");

        setTimeout(() => {
          this.$router.replace("/selectApply/index");
        }, 1500);
      } else {
        this.$toast.fail(res.Msg);
      }
    },
    async save() {
      if (this.sqyy == "") {
        this.$toast.fail("请填写完整申请原因!");
        return;
      }
      if(this.fileList.length==0&&this.qzwffilename==''&&this.isUpLpadFile=='1'){
        this.$toast.fail("请上传附件!");
        return;
      }
      const res = await Api.cjcjShtj({
        cj0708id: this.params.cj0708id,
        cj0712id: this.cjxm.dm,
        sqyy: this.sqyy,
        cjfhsqid: this.params.cjfhsqid,
        file:this.file
      });

      if (res.code == 1 || res.code == "1") {
        if (this.params.ck == "0") {
          this.$toast.success("修改成功!");
        } else {
          this.$toast.success("保存并送审成功!");
        }
        setTimeout(() => {
          this.$router.replace("/selectApply/index");
        }, 1500);
      } else {
        this.$toast.fail(res.Msg);
      }
    },
    async getData() {
      const res = await Api.cjsqxmcj({
        cj0708id: this.params.cj0708id,
        cj0712id: this.cjxm.dm
      });

      this.xmcj = res.data[0].xmcj ? res.data[0].xmcj : "0";
      this.cjbl = res.data[0].cjxmbl ? res.data[0].cjxmbl : "0";
    },
    async getList() {
      const res = await Api.cjcjsqmx({
        cj0708id: this.params.cj0708id,
        jx0404id: this.params.jx0404id,
        cjfhsqid: this.params.cjfhsqid,
        ck: this.params.ck
      });

      if (res.code == "0") {
        this.$toast(res.Msg);
        setTimeout(() => {
          this.$router.back();
        }, 2000);
      } else {
        if (this.params.ck == "1" || this.params.ck == "0") {
          this.cjxm.dm = res.data.cjfhsqlist[0].cj0712id;
          this.sqyy = res.data.cjfhsqlist[0].sqyy;
          this.xmcj = res.data.cjfhsqlist[0].xmcj
            ? res.data.cjfhsqlist[0].xmcj
            : "0";
          this.cjbl = res.data.cjfhsqlist[0].xmcjbl
            ? res.data.cjfhsqlist[0].xmcjbl
            : "0";
        }
        this.isUpLpadFile = res.data.isUpLpadFile;
        this.fileurl = res.data.fileurl;
        this.qzwffilename = res.data.qzwffilename;
        this.list = res.data.cjkclist[0];
        this.columns.cjxm = res.data.cjxmlist.map((item, index) => {
          if (index == 0) {
            this.cjxm = {
              mc: item.cjxmmc,
              dm: item.cj0712id
            };
          }
          if (
            (this.params.ck == "1" || this.params.ck == "0") &&
            item.cj0712id == res.data.cjfhsqlist[0].cj0712id
          ) {
            this.cjxm = {
              mc: item.cjxmmc,
              dm: item.cj0712id
            };
          }
          return {
            text: item.cjxmmc,
            value: item.cj0712id
          };
        });
        this.getData();
      }
    },
    // 弹出选择器
    onShow(label, value) {
      if (this.params.ck == "1") {
        return;
      }
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].mc = value.text;
      this[value1].dm = value.value;
      if (value1 == "cjxm" && this.cjxm.dm != "zcj") {
        this.getData();
      }
    },
    afterRead(file) {
          // 此时可以自行将文件上传至服务器
          this.file = file.file;
          console.log(this.file);   
      },
      onOversize(file) {
          this.$toast.fail("文件大小不能超过2M");
      },
      CheckFile(){
        if(this.fileurl==''&&this.qzwffilename==''){
          return;
        }
        this.fileYlData.fileurl = this.fileurl;
        this.fileYlData.qzwffilename = this.qzwffilename;
        let listTemp={};
        listTemp.route = '/selectApply/index';
        localStorage.setItem("shyjData", JSON.stringify(this.fileYlData));
        this.$router.push({
          path: "/teacher/filePreview",
          query: { 
             isCjsq:'1',
             route:'/selectApply/index',
             list:this.$route.query.list
          },
        });
      }
  }
};
</script>
<style lang="less" scoped>
.trainIndex .train {
  padding: 5% 5% 0;
  .list-head {
    background-image: url("../../../../../static/image/head.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    padding: 6% 7%;
    box-sizing: border-box;
    margin-bottom: 5%;
    position: relative;
    flex-direction: column;
    p {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #fff;
      letter-spacing: 0;
      margin-bottom: 2%;
      font-weight: bold;
    }
    ul li {
      font-family: PingFangSC-Light;
      font-size: 12px;
      color: #fff;
      letter-spacing: 0;
      margin-bottom: 1%;
      font-weight: lighter;
    }
    span {
      position: absolute;
      top: 15%;
      right: 7%;
      color: #fff;
      border-radius: 40%;
      font-size: 14px;
      padding: 1% 3%;
      background-color: #8f87f9;
    }
  }

  .van-cell {
    padding: 10px 0;
    border-bottom: 1px solid #f4f4f4;
  }
  .van-cell::after {
    display: none;
  }
  .van-field__label {
    width: 7.2em;
  }
  .van-cell.van-field .van-cell__title.van-field__label > span {
    font-family: PingFangSC-Light;
    font-size: 16px;
    color: #212f6e;
    letter-spacing: 0;
  }
  .van-field__control::-webkit-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    letter-spacing: 0;
    font-weight: normal;
    text-align: right;
  }
  .van-field__control::-moz-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    font-weight: normal;
    letter-spacing: 0;
    text-align: right;
  }
  .van-field__control::-ms-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    letter-spacing: 0;
    font-weight: normal;
    text-align: right;
  }
  .van-field__control {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #212f6e;
    letter-spacing: 0;
    text-align: right;
    font-weight: bolder;
  }
  .van-icon-arrow {
    color: #dfe0e6;
    font-weight: bolder;
    font-size: 14px;
  }
}
.bottom-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  padding-bottom: 10px;
  padding: 0 5%;
  background: #fff;
  box-sizing: border-box;

  button {
    width: 100%;
    height: 44px;
    background: #7469f8;
    border-radius: 3px;
    color: #fff;
  }
}
.bottom-btn1 {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  padding-bottom: 10px;
  padding: 0 5%;
  background: #fff;
  box-sizing: border-box;

  button:first-child {
    width: 47.5%;
    height: 44px;
    background: #ecedfd;
    border-radius: 3px;
    color: #7469f8;
  }
  button:last-child {
    width: 47.5%;
    height: 44px;
    background: #7469f8;
    border-radius: 3px;
    color: #fff;
    float: right;
  }
}
.apply-input{padding: 9px 0;display: flex;align-items: center;justify-content: space-between;border-bottom: 1px solid @attendance-border-color-6;color: @attendance-color-1;}
.apply-input input{flex: 1;text-align: right;color: @attendance-color-1;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;padding-left: 20px;}
.apply-input input::placeholder{color: @attendance-background-color-2;font-size: 16px;}
.apply-input .arrow{background: url(../../../../../static/img/arrow_r.png)no-repeat center;width: 13px;height: 13px;background-size: 13px 13px;margin-left: 10px;}
.apply-input p{
  color: #757DA3;
}
.fujianImg{
    background: url(../../../../assets/images/fujian.png)no-repeat center;
    background-size: 18px 18px;width: 18px;height: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/selectApply/apply.vue